import { Popover, PopoverActions } from '@material-ui/core';
import { Body } from 'copilot-design-system';
import { useEffect, useRef, useState } from 'react';

import { AddressInputForm } from 'src/features/crm/properties/AddressInput/AddressInputForm';
import { CustomFieldValueData } from 'src/features/crm/types/type';
import {
  AddressCustomField,
  AddressCustomFieldValues,
} from 'src/store/clients/types';

interface AddressInputProps {
  field: AddressCustomField;
  value: AddressCustomFieldValues;
  placeholder: string;
  onSaveValue: (property: CustomFieldValueData) => void;
  onClose?: () => void;
  renderAsCell?: boolean;
  shouldOpenMenu?: boolean;
}

const AddressInput = ({
  field,
  value,
  placeholder,
  onSaveValue,
  onClose,
  renderAsCell,
  shouldOpenMenu,
}: AddressInputProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const popoverActions = useRef<PopoverActions>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // open the popover when shouldOpenMenu is set to true
  useEffect(() => {
    if (shouldOpenMenu && containerRef !== null) {
      setAnchorEl(containerRef.current);
    }
  }, [shouldOpenMenu]);

  return (
    <>
      <div
        ref={containerRef}
        className="w-full flex items-center cursor-pointer min-h-8"
        onClickCapture={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        {renderAsCell ? (
          <Body size="sm" className="text-ellipsis overflow-hidden">
            {value.fullAddress}
          </Body>
        ) : (
          <>
            {!value.fullAddress ? (
              <Body size="sm" className="text-light-gray  leading-[21px]">
                {placeholder}
              </Body>
            ) : (
              <Body
                className="leading-[21px] pr-4 text-ellipsis overflow-hidden"
                size="sm"
              >
                {value.fullAddress}
              </Body>
            )}
          </>
        )}
      </div>
      <Popover
        onClose={() => {
          if (onClose) onClose();
          setAnchorEl(null);
        }}
        open={anchorEl !== null}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        action={popoverActions}
        classes={{
          paper:
            'border border-solid border-secondary-hover shadow-dropdown-menu w-[263px]',
        }}
      >
        <AddressInputForm
          fieldId={field.id}
          initialValues={{
            addressLine1: value.addressLine1 ?? '',
            addressLine2: value.addressLine2 ?? '',
            city: value.city ?? '',
            country: value.country ?? '',
            fullAddress: value.fullAddress ?? '',
            region: value.region ?? '',
            postalCode: value.postalCode ?? '',
          }}
          onClosePopover={() => {
            setAnchorEl(null);
            if (onClose) onClose();
          }}
          onUpdatePopoverPosition={() => {
            if (popoverActions.current) {
              popoverActions.current.updatePosition();
            }
          }}
          onSaveValue={onSaveValue}
        />
      </Popover>
    </>
  );
};

export default AddressInput;
